// extracted by mini-css-extract-plugin
module.exports = {"region-table":"RegionUnits_region-table__1o6CK"};